import { customAxios } from './customAxios'
export function deleteNodeById(idNode, idPratica) {
  const config = {
    headers: {
      Accept: '*/*',
      AuthToken: JSON.parse(localStorage.getItem('token')),
    },
    params: {
      idNode,
      idPratica,
    },
  }
  const deleteNode = customAxios
    .get(
      process.env.REACT_APP_BACKEND_HOST +
        '/' +
        process.env.REACT_APP_PATH_NEW_PREFIX +
        '/deleteNodeById?',
      config,
    )
    .then(res => res.data.body)
  return deleteNode
}
